import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/contexts';
import { fetchListaDocumentos } from '../api/ListaDocumentosApi';
import { FiltrosDocumentos, ListaDocumentosResponse } from '../types';

export function useListaDocumentos(
  filtros?: FiltrosDocumentos,
  options?: Omit<UseQueryOptions<ListaDocumentosResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const { toast } = useToast();
  const { user } = useAuth();
  const cnpjGestor = user?.cnpj;

  const query = useQuery<ListaDocumentosResponse, Error>({
    queryKey: ['documentos', cnpjGestor, filtros],
    queryFn: () => fetchListaDocumentos(filtros),
    staleTime: 5 * 60 * 1000,
    ...options,
    enabled: (options?.enabled ?? true) && !!cnpjGestor,
  });

  useEffect(() => {
    if (query.error) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar documentos',
        description: 'Não foi possível carregar a lista de documentos. Tente novamente.',
      });
    }
  }, [query.error, toast]);

  return query;
}
